import { Component } from '@angular/core';
import { FormGroup, UntypedFormBuilder } from '@angular/forms';
import { Utility } from '../../shared/utility/utility';
@Component({
  selector: 'app-myaccount-shared',
  templateUrl: './myaccount-shared.component.html',
  styleUrls: ['./myaccount-shared.component.scss']
})
export class MyaccountSharedComponent {
  static formgroup: FormGroup;
  public enddate: Date;
  public startdate: Date;

  mobi_desktop_startDate = {
    theme: 'ios',
    themeVariant: 'light',
    controls: ['calendar'],
    display: 'anchored',
    buttons: false,
    onClose: (event, inst) => {
      console.log(event)
      console.log(inst)
      this.dateChangeHandler(MyaccountSharedComponent["formgroup"], 'enddate', 'desktop');
    }
  }
 
  mobi_desktop_endDate = {
    theme: 'ios',
    themeVariant: 'light',
    controls: ['calendar'],
    display: 'anchored',
    buttons: false,
    onClose: (event, inst) => {
      console.log(event)
      console.log(inst)
      this.dateChangeHandler(MyaccountSharedComponent["formgroup"], 'startdate', 'desktop');
    }
  }
 
  /*Picking up date change events from mobiscroll on mobile*/
  public mobi_mobile_startDate = {
    theme: 'ios',
    themeVariant: 'light',
    touchUi: "true",
    controls: ['date'],
    display: 'bottom',
    buttons: false,
    onClose: (event, inst) => {
      this.dateChangeHandler(MyaccountSharedComponent["formgroup"], 'enddate', 'mobile');
    }
  };
 
  public mobi_mobile_endDate = {
    theme: 'ios',
    themeVariant: 'light',
    touchUi: "true",
    controls: ['date'],
    display: 'bottom',
    buttons: false,
    onClose: (event, inst) => {
      this.dateChangeHandler(MyaccountSharedComponent["formgroup"], 'startdate', 'mobile');
    }
  };
  

  constructor(private utility: Utility) {}

  /* Function called on event : Date change through mobiscroll on mobile*/
  dateChangeHandler(form: FormGroup, target: String, deviceType?) {
    this.resetDate(form, target);
  }

  /*
    Function for resetting date : if user selects startdate then auto change the end date.
    If user selects the end date auto select the start date.
    This function is called by both device and mobile.
  */
 resetDate(form: FormGroup, target: String) {
    let startdate = new Date(form.controls["startDate"].value);
    let copyStartDate = new Date(form.controls["startDate"].value);
    let enddate = new Date(form.controls["endDate"].value);
    let copyEndDate = new Date(form.controls["endDate"].value);
    if (target === "enddate") {
      let sevenDaysAheadDate = new Date(copyStartDate.setDate(copyStartDate.getDate() + 7));
      if ((new Date(form.controls["endDate"].value) > sevenDaysAheadDate) || (startdate > enddate)) {
        this.enddate = new Date(startdate.setDate(startdate.getDate() + 7));
        if (this.enddate > new Date()) {
          this.enddate = new Date();
        }
      }else {
        this.enddate = enddate;
      }
      form.controls["endDate"].setValue(this.enddate);
    } else {
      let sevenDaysAgoDate = new Date(copyEndDate.setDate(copyEndDate.getDate() - 7));
      if ((new Date(form.controls["startDate"].value) < sevenDaysAgoDate) ||  (startdate > enddate)) {
        this.startdate = new Date(enddate.setDate(enddate.getDate() - 7));
      }else {
        this.startdate = startdate;
      }
      form.controls["startDate"].setValue(this.startdate);
    }
  }
  closeModal(modalId){
    this.utility.closeModal(modalId);
  }
  shouldShowErrors(fieldName, formName){
    return this.utility.shouldShowErrors(fieldName, formName);
  }
  getErrorMessage(fieldName, formName){
    return this.utility.getErrorMessage(fieldName, formName);
  }
  getButtonClass(formName, fieldName){
    return this.utility.getButtonClass(formName, fieldName);
  }
  isButtonDisabled(formName){
    return this.utility.isButtonDisabled(formName);
  }
}
